module.exports = __webpack_public_path__ + "static/media/YF71_3.ce354e37.jpg";